import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-900 px-4 pb-24 pt-14 sm:px-6 sm:pb-14" data-id="element-42" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-3xl text-center" data-id="element-43" data-mp="3gg10g6ubc3z8">
        <p className="font-display text-xl font-bold text-white sm:text-2xl" data-id="element-44" data-mp="32nummremu92y">
          DVO Clinical Workflow Builder™
        </p>
        <p className="mt-2 text-[13.5px] text-white/60" data-id="element-45" data-mp="36oo5359b2vog">
          Build your workflow. Organize your cases. Repeat your process.
        </p>
        <p className="mt-4 text-[10.5px] font-bold uppercase tracking-[0.18em] text-go" data-id="element-46" data-mp="3ucxpc2qvfbdh">
          Created by Dr. Karito
        </p>

        <p className="mx-auto mt-8 max-w-2xl text-[11.5px] leading-relaxed text-white/45" data-id="element-47" data-mp="3lelzi2xtwhm3">
          Educational material only. This product does not provide diagnosis or treatment
          recommendations and does not replace professional clinical judgment, professional
          training, individualized patient care, institutional protocols or applicable standards of
          care. Application of any educational material should be adapted to the individual patient
          and the responsible clinician’s professional judgment.
        </p>

        <p className="mt-6 text-[11.5px] text-white/40" data-id="element-48" data-mp="3gc0ixoj3k29q">
          © 2026 Dr. Karito. All rights reserved.
        </p>
      </div>
    </footer>;
}